export enum CfmTransferOrderStatusModel {
  Pending = "pending",
  Confirmed = "confirmed",
}
